export const GET_OTP_REQUEST = "GET_OTP_REQUEST";
export const GET_OTP_SUCCESS = "GET_OTP_REQUEST";
export const GET_OTP_REQUEST_SUCCESS = "GET_OTP_REQUEST_SUCCESS";
export const GET_VERIFY_REQUEST = "GET_VERIFY_REQUEST";
export const GET_VERIFY_REQUEST_SUCCESS = "GET_OTP_REQUEST_SUCCESS";
export const CHANGE_VIEW_MODAL = "CHANGE_VIEW_MODAL";
